import { render, staticRenderFns } from "./waterMeterForm.vue?vue&type=template&id=10e6becc&scoped=true&"
import script from "./waterMeterForm.vue?vue&type=script&lang=ts&"
export * from "./waterMeterForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6becc",
  null
  
)

export default component.exports